"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.manualEntry_1 = void 0;
var manualEntry_1 = function (utils) {
    var loadPrimaryInput = utils.loadPrimaryInput, a11yHasExpectedHtml = utils.a11yHasExpectedHtml, a11yInitialHtml = utils.a11yInitialHtml, hasReturnVal = utils.hasReturnVal;
    describe('Manual entry - 1', function () {
        it('1 1 1 1 A', function () {
            loadPrimaryInput({ segment: 'hrs12' })
                .type('1')
                .should('have.value', '01:30 PM')
                .then(a11yHasExpectedHtml('<p>1.</p>'))
                .then(hasReturnVal('13:30'))
                .type('1')
                .should('have.value', '11:30 PM')
                .then(a11yHasExpectedHtml(a11yInitialHtml().minutes))
                .then(hasReturnVal('23:30'))
                .type('1')
                .should('have.value', '11:01 PM')
                .then(a11yHasExpectedHtml('<p>1.</p>'))
                .then(hasReturnVal('23:01'))
                .type('1')
                .should('have.value', '11:11 PM')
                .then(a11yHasExpectedHtml(a11yInitialHtml().mode))
                .then(hasReturnVal('23:11'))
                .type('a')
                .should('have.value', '11:11 AM')
                .then(a11yHasExpectedHtml('<p>AM.</p>'))
                .then(hasReturnVal('11:11'));
        });
    });
};
exports.manualEntry_1 = manualEntry_1;
